import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

type AvailableAction = 'list' | 'download' | null;

export type ActionProfileIds = string[]; // list of profile ids to be added to list

export type State = {
  currentAction: AvailableAction;
  actionProfileIds: Record<string, true>; // data to be added-to-list/downloaded
};

type Action = {
  setCurrentAction: (action: AvailableAction) => void;
  setActionProfileIds: (ids: ActionProfileIds) => void;
};

/**
 * Store to maintain state of search list record's bulk action like(add-to-list/download multiple records)
 */
const useAction = create<State & Action>()(
  devtools(
    immer((set) => ({
      currentAction: null,
      actionProfileIds: {},
      setCurrentAction: (action: AvailableAction) =>
        set({ currentAction: action }, false, { type: 'SET_CURRENT_ACTION' }),
      setActionProfileIds: (profileIds) => {
        const result = profileIds.reduce(
          (obj, id) => {
            obj[id] = true;
            return obj;
          },
          {} as Record<string, true>,
        );
        set({ actionProfileIds: result }, false, { type: 'SET_ACTION_PROFILE_IDS' });
      },
    })),
    {
      store: 'SearchListRecordsBulkAction',
    },
  ),
);

export { useAction };
